// extracted by css-extract-rspack-plugin
export default {"markdownRoot":"Markdown-module__markdownRoot___VvvrT","lineClamp":"Markdown-module__lineClamp___pAzZ4","tableScroll":"Markdown-module__tableScroll___Psbbc"};